import React, { useRef, useEffect } from 'react';
import { useEventActions } from 'src/store/event/actions';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteRegistrationFieldModal } from 'src/models/eventModel';
import { Link, useParams } from 'react-router-dom';
import { RootState } from 'src/store/reducers/state';
interface IProps {
    reminderNumber: number;
}
const DeleteEventReminderModal: React.FC<IProps> = ({ reminderNumber }) => {
    const dispatch = useDispatch();
    const eventActions = useEventActions(dispatch)
    const { eventId } = useParams<string>();
    const ref = useRef<HTMLButtonElement>(null);
    const handleDeleteClick = () => {
        if (eventId) {
            eventId && eventActions.deleteEventReminderRequest({ eventId, reminderNumber })
        }
    };
    const { isEventReminderDeleted } = useSelector((state: RootState) => {
        return {
            isEventReminderDeleted: state.event.isEventReminderDeleted
        };
    });
    useEffect(() => {
        if (isEventReminderDeleted) {
            if (ref.current) {
                ref.current.click();
            }
            eventActions.resetEventStateRequest();
        }
    }, [isEventReminderDeleted]);
    return (
        <div>
            <div
                className="modal fade"
                id="DeleteEventReminderModal"
                aria-labelledby="DeleteEventReminderModalLabel"
                aria-hidden="true">
                <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
                    <div className="modal-content">
                        <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
                            <h5
                                className="text-xl font-semibold leading-normal text-center w-full"
                                id="DeleteEventModalLabel">
                                Delete Event Reminder
                            </h5>
                            <button
                                ref={ref}
                                type="button"
                                className="dismiss-btn"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body relative py-4 px-10">
                            <form>
                                <div className={`form-group mb-3 text-center`}>
                                    <p>
                                        <strong>Are you sure you want to delete this?</strong>
                                    </p>
                                </div>
                            </form>
                        </div>

                        <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-center p-4 pb-6 pt-0 rounded-b-md">
                            <button
                                onClick={handleDeleteClick}
                                type="button"
                                className="px-6 btn-primary w-auto whitespace-nowrap mr-2 ml-0 mt-0 borderonly-btn">
                                Delete
                            </button>
                            <button
                                type="button"
                                className="mx-0 px-6 btn-primary discard-btn w-auto whitespace-nowrap mt-0"
                                data-bs-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteEventReminderModal;
